import { Icon } from "@/components/icons";

type StatCardProps = {
  icon: string;
  label: string;
  value: string;
  /** Empty-state styling: grey icon box, grey-300 value. */
  dim?: boolean;
  /** Value not fetched yet — shimmer in its place instead of a misleading 0. */
  loading?: boolean;
};

export function StatCard({ icon, label, value, dim = false, loading = false }: StatCardProps) {
  const iconBoxClass = dim
    ? "border-grey-200 bg-grey-50 text-grey-900"
    : "border-green-500-12 bg-green-200 text-green-700";
  const valueClass = dim ? "text-grey-300" : "text-black";
  return (
    <div
      aria-busy={loading || undefined}
      className="flex flex-1 items-start gap-4 rounded-[4px] border border-grey-200 bg-white p-3 shadow-flat"
    >
      <div
        className={`flex size-[52px] shrink-0 items-center justify-center rounded-[4px] border ${iconBoxClass}`}
      >
        <Icon name={icon} size={24} weight={300} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col items-start justify-center">
        <span className="text-small font-medium text-grey-950">{label}</span>
        {loading ? (
          <span aria-hidden className="flex h-8 items-center">
            <span className="h-6 w-16 animate-pulse rounded-sm bg-grey-200" />
          </span>
        ) : (
          <span className={`text-h3 font-bold ${valueClass}`}>{value}</span>
        )}
      </div>
    </div>
  );
}
